import { Loader2 } from 'lucide-react';
import cn from '../../utils/cn';

/** Skeletons matched to the final layout — never a full-page spinner. */

export function Skeleton({ width = '100%', height = 12, radius = 4, style }) {
  return <div className="skeleton" style={{ width, height, borderRadius: radius, ...style }} />;
}

/** Row skeleton. `bare` renders the rows without their own panel (when already inside one). */
export function TableSkeleton({ rows = 8, bare = false }) {
  const body = Array.from({ length: rows }).map((_, r) => (
    <div key={r} className="row" style={{ gap: 12, padding: '10px 16px', borderTop: '1px solid var(--row-rule)' }}>
      <Skeleton width={30} height={30} radius={7} />
      <div className="stack" style={{ gap: 6, flex: 1 }}>
        <Skeleton width={`${45 + ((r * 13) % 35)}%`} height={11} />
        <Skeleton width="28%" height={9} />
      </div>
      <Skeleton width={70} height={10} />
    </div>
  ));
  if (bare) return <div aria-hidden="true">{body}</div>;
  return (
    <div className="panel panel-list" aria-hidden="true">
      <div style={{ padding: '10px 16px' }}>
        <Skeleton width={120} height={10} />
      </div>
      {body}
    </div>
  );
}

export function GridSkeleton({ count = 8 }) {
  return (
    <div className="grid-cards" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="panel" style={{ padding: 14 }}>
          <div className="row" style={{ justifyContent: 'space-between', marginBottom: 10 }}>
            <Skeleton width={36} height={36} radius={9} />
            <Skeleton width={60} height={9} />
          </div>
          <Skeleton width="82%" height={11} style={{ marginBottom: 8 }} />
          <Skeleton width="100%" height={9} style={{ marginBottom: 4 }} />
          <Skeleton width="70%" height={9} />
        </div>
      ))}
    </div>
  );
}

export function PanelSkeleton({ rows = 6 }) {
  return (
    <div className="stack" style={{ gap: 16 }} aria-hidden="true">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="stack" style={{ gap: 6 }}>
          <Skeleton width="34%" height={9} />
          <Skeleton width="68%" height={12} />
        </div>
      ))}
    </div>
  );
}

export function CardsSkeleton({ count = 4 }) {
  return (
    <div className="grid-stats" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="stat-card">
          <Skeleton width={38} height={38} radius={10} />
          <div className="stack" style={{ gap: 6 }}>
            <Skeleton width={48} height={18} />
            <Skeleton width={90} height={9} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function InlineSpinner({ label, className }) {
  return (
    <div className={cn('row muted', className)} style={{ gap: 8, fontSize: 12.5 }}>
      <Loader2 size={14} className="spin" />
      {label}
    </div>
  );
}

export function LoadingBar() {
  return (
    <div className="progress progress--indeterminate" style={{ height: 3 }}>
      <div className="progress__bar" />
    </div>
  );
}

export default TableSkeleton;
